export default "__VITE_PUBLIC_ASSET__85a5693c__"